export const fragenAudi = [
  {
    question: "Kann ich meinen Audi mit Motorschaden verkaufen?",
    answer: (
      <>
        <p>
          Ja. Ein professionelles Gutachten ermittelt den Restwert, und viele
          Händler kaufen defekte Autos.
        </p>
      </>
    ),
  },
  {
    question: "Muss ich das Auto reparieren?",
    answer: (
      <>
        <p>
          Nein. Bei einem wirtschaftlichen Totalschaden lohnt eine Reparatur
          selten. Verkaufe den Wagen im Ist-Zustand.
        </p>
      </>
    ),
  },
  {
    question: "Wer übernimmt Abholung und Ummeldung?",
    answer: (
      <>
        <p>
          Autoeinfachlos organisiert die Abholung. In Österreich nehmen
          Hersteller und Importeure nicht fahrbereite Fahrzeuge kostenlos zurück
          und kümmern sich um Entsorgung.
        </p>
      </>
    ),
  },
  {
    question: "Wie lange dauert der Verkauf?",
    answer: (
      <>
        <p>
          Nach der Online-Bewertung erhältst du in der Regel innerhalb weniger
          Stunden Angebote. Die Abwicklung kann oft innerhalb weniger Tage
          abgeschlossen werden.
        </p>
      </>
    ),
  },
];
